import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/data_store';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Auth0Provider } from '@auth0/auth0-react';
const CIAM_Redirect=process.env.REACT_APP_API_CIAM_REDIRECT_URI;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
      domain="lauritz-knudsen-preprod.eu.auth0.com"
      clientId="nAHQtGkPW2T88cWHCP9vZoQJw6Ayt1zs"
      grant_type= "authorization_code"
      //audience= "lk-ea-preprod-api"
      authorizationParams= {{
        redirect_uri: CIAM_Redirect,
        audience: "lk-ea-preprod-api"
      }}
      //onRedirectCallback={onRedirectCallback}
    >
  {/* <React.StrictMode> */}
    <Provider store={store}>
      <App />
    </Provider>
  {/* </React.StrictMode> */}
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
